export const HIDE_COOKIES = "HIDE_COOKIES";

export const COOKIES_SHAPE = {
  visible: false,
}